/**
 * Manipulate objects
 */
function existInObjectName(object, idSearch) {
  return object.some(item => item.name === idSearch);
}

function findInObjectName(object, idSearch) {
  return object.find(item => item.name === idSearch);
}

function existInObjectCycle(object, idSearch) {
  return object.some(item => item.cycle === idSearch);
}

function findInObjectCycle(object, idSearch) {
  return object.find(item => item.cycle === idSearch);
}

function existInObjectSoRealName(object, idSearch) {
  return object.some(item => item.display_name === idSearch);
}

function findInObjectSoRealName(object, idSearch) {
  return object.find(item => item.display_name === idSearch);
}

function toCamelCase(str) {
  return str.replace(/[-_](.)/g, (_, char) => char.toUpperCase());
}

function setOrderSettingsFromUrl() {

  /**
   * zone parameters
   */
  const availableParamZones = ['br', 'en']
  if (this.$route.query.zone && availableParamZones.includes(this.$route.query.zone.toLowerCase())) {
    if (this.$route.query.zone === 'en') {
      this.selectDatacenter(3)
    } else {
      this.selectDatacenter(2)
    }
  }
}

function setCategoryLoadSettingsFromUrl() {
  /**
   * product parameters
   */
  if (this.$route.query.category && existInObjectName(this.categories, this.$route.query.category.toUpperCase())) {
    this.setSelectedCategory(findInObjectName(this.categories, this.$route.query.category.toUpperCase()))
  }
}

function setOrderProductSettingsFromUrl() {
  /**
   * Plans parameters
   */
  if (this.$route.query.plan && existInObjectName(this.products, this.$route.query.plan)) {
    let plan = findInObjectName(this.products, this.$route.query.plan)

    this.selectProduct(plan)
    this.selectDefaultProduct(plan.prices)
  }
}

function setBillingCycleSettingsFromUrl() {
  /**
   * Billing Cycle parameters
   */
  const availableBillingCycle = [
    'Monthly',
    'Quarterly',
    'SemiAnnually',
    'Annually'
  ]

  if (this.$route.query.billing_cycle &&
    availableBillingCycle.includes(toCamelCase(this.$route.query.billing_cycle)) &&
    existInObjectCycle(this.cycles, this.$route.query.billing_cycle)) {
    let cycle = findInObjectCycle(this.cycles, this.$route.query.billing_cycle)

    this.setCycle(cycle)
  }
}

function setSoSettingsFromUrl() {
  if (this.$route.query.so && existInObjectSoRealName(this.templates[0].templates, this.$route.query.so)) {
    this.selectedTemplate = findInObjectSoRealName(this.templates[0].templates, this.$route.query.so)
  }
}

function setSettingsFromUrl() {

  const availableSettings = this.productSettings.map(item => item.name);

  availableSettings.forEach(item => {
    if (this.$route.query[item]) {
      let setting = findInObjectName(this.productSettings, item);

      if (parseInt(this.$route.query[item]) >= setting.min_value &&
        parseInt(this.$route.query[item]) <= setting.max_value) {
        let updateSetting = setting;
        updateSetting.value = parseInt(this.$route.query[item])

        this.updateOrder(updateSetting);
      }
    }
  });
}

export {
  setOrderSettingsFromUrl,
  setCategoryLoadSettingsFromUrl,
  setOrderProductSettingsFromUrl,
  setBillingCycleSettingsFromUrl,
  setSoSettingsFromUrl,
  setSettingsFromUrl
}



// WEBPACK FOOTER //
// ./src/components/order/AutoloadPlans.js